import type { FormatMessage } from '@atlassian/jira-shared-types/src/general.tsx';
import messages from './messages.tsx';

export const getErrorMessage = (
	issueKey: string,
	issuesWithMissingResolvePermission: readonly string[] | null | undefined,
	issuesWithMissingEditPermission: readonly string[] | null | undefined,
	formatMessage: FormatMessage,
): string => {
	const issueIsMissingResolvePermission =
		issuesWithMissingResolvePermission !== null &&
		issuesWithMissingResolvePermission !== undefined &&
		issuesWithMissingResolvePermission.length > 0;

	const issueIsMissingEditPermission =
		issuesWithMissingEditPermission !== null &&
		issuesWithMissingEditPermission !== undefined &&
		issuesWithMissingEditPermission.length > 0;

	if (issueIsMissingResolvePermission && issueIsMissingEditPermission) {
		return formatMessage(messages.missingPermissionsErrorFlagDescription, { issueKey });
	}

	if (issueIsMissingResolvePermission) {
		return formatMessage(messages.missingResolvePermissionErrorgFlagDescription, { issueKey });
	}

	if (issueIsMissingEditPermission) {
		return formatMessage(messages.missingEditPermissionErrorFlagDescription, { issueKey });
	}

	return formatMessage(messages.errorFlagDescription);
};
